import { SpendingType } from './../entities/spending-type';
import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 
import { SpendingConcept } from '../entities/spending-concept';

@Injectable()
export class SpendingConceptService extends BaseCrudService<SpendingConcept> {

  public uri = '/api/spendingConcept/';

  constructor(injector: Injector) {
    super(injector); 
  }
 
 getFormatDate() { 
    const url = `${this.rutaServidor}${this.uri}getFormatDate`;
    return this.httpClient.get<SpendingConcept>(url);
  }
 

  buildSentence(entity?: SpendingConcept, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Equal}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/spending-concept.service.ts